import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, } from 'chart.js';
import { Line } from 'react-chartjs-2';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import moment from 'moment';
import ChartLoader_Bus from '../ChartLoader_Bus';
import ChartLoaderDay from '../ChartLoaderDay';
import NoData from '../NoData';
import { BsFillArrowLeftSquareFill, BsFillArrowRightSquareFill } from "react-icons/bs";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function DayWiseChart(props) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    let { gloablfilter } = props;

    let apiprops = {};
    apiprops = props.apiprops;
    apiprops.vin = props.clickedIndex;
    let monthStr = props.apiprops.month

    const [duration, setDuration] = useState(props.duration);

    function convertMonthToDates(monthStr) {
        const parsedMonth = moment(monthStr, 'MMM YYYY');
        const firstDayy = parsedMonth.startOf('month').format('YYYY-MM-DD');
        const lastDayy = parsedMonth.endOf('month').format('YYYY-MM-DD');
        return [firstDayy, lastDayy];
    }

    const [firstDay, setFirstDay] = useState('');
    const [lastDay, setLastDay] = useState('');

    useEffect(() => {
        if (duration === '7D') {
            setFirstDay((moment().subtract(7, 'days').format('YYYY-MM-DD')));
            setLastDay((moment().subtract(1, 'days').format('YYYY-MM-DD')));
        } else {
            const [start, end] = convertMonthToDates(monthStr);
            setFirstDay(start);
            setLastDay(end);
        }
    }, [duration, monthStr]);


    const [dayLabel, setDayLabel] = useState([]);
    const [dayData, setDayData] = useState([]);

    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + "trend_analysis_drive_bus/dayWiseTrend",
                body: {
                    filterdata: {
                        "CITY": [apiprops.city],
                        "DEPO": [apiprops.depo],
                        "LOB": [],
                        "PL": [],
                        "PPL": [],
                        "SOC": 0,
                        "VIN_NUM": [apiprops.vin],
                        "endDate": lastDay,
                        "pageSelected": 1,
                        "startDate": firstDay,
                        // "startDate": "2023-10-02",
                        // "endDate": "2023-10-08",
                        "AIR_VENTILATION": "",

                    }
                },
            },
            responceDataDate
        );
    }, [props, firstDay, lastDay]);

    const responceDataDate = (data) => {
        setDayLabel(data.uniqueEventDay)
        setDayData(Object.values(data.newData))
    }

    const colorPalette = ['#02559b', '#83a3ce', '#ced9e9', '#6081AA', '#3D6087', '#D4DFEB', '#184165', '#002446', '#1E618E', '#53749D', '#AFCFFC', '#949BE6',];

    const labels = dayLabel

    const datasets = dayData.map((dataList, index) => ({
        label: apiprops.vin,
        data: dataList,
        backgroundColor: colorPalette[index % colorPalette.length],
        borderColor: colorPalette[index % colorPalette.length],
    }));

    const data = {
        labels,
        datasets: datasets
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                // position: 'top' as const,
            },

            title: {
                display: true,
            },
            datalabels: {
                color: '#3D6087', // color of the data labels
                anchor: 'end', // position of the data labels
                align: 'end', // alignment of the data labels
                rotation: 270,
                font: {
                    weight: 'bold', // make the text bold
                },
                formatter: function (value, context) {
                    return value.toFixed(2); // format how the data labels appear
                }
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // hide x-axis grid lines
                },
            },
            y: {
                grid: {
                    display: false, // hide y-axis grid lines
                },
            },
        },
    };

    const handleBackDetails = (e) => {
        props.onreset(duration);
    };

    return (
        <div className='row titlebg_bus_trend'>
            <div className='col-md-1 pt-2'><BsFillArrowLeftSquareFill onClick={handleBackDetails} style={{ fontWeight: "bold", color: "#02559b", cursor: "pointer", fontSize: "2em" }} /></div>
            <div className="col-md-11 ">
                <div className="text-fit" style={{ textAlign: "left" }}>Range(km) Analysis</div>
            </div>{(isLoading) ? <ChartLoaderDay /> :
                (dayData.length === 0) ? <NoData /> :
                    <Line options={options} data={data} height={(window.innerWidth > 768) ? 103 : 300} width="auto" paddingTop="0px" plugins={[ChartDataLabels]} />}
        </div>
    )
}
